const hazardStatus = [
  { id: 1, value: 'Raised' },
  { id: 2, value: 'Managed' },
  { id: 3, value: 'Removed' },
  { id: 4, value: 'Deleted' }
];

export default { hazardStatus };
